import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-41307e56"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"display":"none"}
}
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "segmentMame",
  class: "small-label"
}, "Название сегмента", -1))
const _hoisted_4 = { class: "flex flex-col m-t-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "small-label"
}, "Дата создания", -1))
const _hoisted_6 = { class: "flex flex-col m-t-8" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Статус сегмента", -1))
const _hoisted_8 = { class: "flex flex-col m-t-8" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "small-label"
}, "Тип сегмента", -1))
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "flex flex-col m-t-8" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Категория", -1))
const _hoisted_13 = { class: "flex flex-col m-t-8" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Бренд", -1))
const _hoisted_15 = { class: "flex flex-col m-t-8" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Магазин", -1))
const _hoisted_17 = { class: "flex flex-col m-t-8" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Автор", -1))
const _hoisted_19 = { class: "flex flex-col m-t-8" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Фильтр по полу", -1))
const _hoisted_21 = { class: "gender-filter-section" }
const _hoisted_22 = { class: "female-male-container" }
const _hoisted_23 = { class: "gender-option" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "maleCheckbox",
  class: "gender-checkbox-label"
}, "Мужчины", -1))
const _hoisted_25 = { class: "gender-option" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "femaleCheckbox",
  class: "gender-checkbox-label"
}, "Женщины", -1))
const _hoisted_27 = { class: "flex flex-col m-t-8" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Фильтр по возрасту", -1))
const _hoisted_29 = { class: "gender-filter-section" }
const _hoisted_30 = { class: "age-container" }
const _hoisted_31 = ["for"]

import InputText from "primevue/inputtext";
import Calendar from "primevue/calendar";
import MultiSelect from "primevue/multiselect";
import Checkbox from "primevue/checkbox";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import CategoryTreeInput from "@/entities/segments/forms/CategoryTreeInput.vue";
import ListFilterForm from "@/widgets/forms/ListFilterForm.vue";

import { useSegmentsDictionariesStore } from "@/store/dictionaries/segments";
import {
  GENDER_VALUES,
  toggleGenderValue,
  toggleAgeValue,
} from "@/services/segments/utils";
import { useAgesStore } from "@/store/catalog_data/ages";
import { computed, ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SegmentsFilterForm',
  props: {
    isFilterEnabled: { type: Boolean }
  },
  emits: ["toggleFilter", "setFilter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const segmentsDictionariesStore = useSegmentsDictionariesStore();
const agesStore = useAgesStore();

const initialFilter = {
  name: "",
  date: null,
  state: [] as number[],
  type: [] as number[],
  user: [] as number[],
  brand: [] as string[],
  category: [] as any[],
  shop: [] as number[],
  gender: [] as number[],
  age: [] as number[],
};

// Ref для хранения ссылки на slotProps
const slotPropsRef = ref<any>(null);

// Computed свойства для чекбоксов gender
const maleCheckbox = computed({
  get: () => {
    return (
      slotPropsRef.value?.filter?.gender?.includes(GENDER_VALUES.MALE) || false
    );
  },
  set: (value: boolean) => {
    if (slotPropsRef.value?.filter) {
      slotPropsRef.value.filter.gender = toggleGenderValue(
        slotPropsRef.value.filter.gender || [],
        GENDER_VALUES.MALE
      );
    }
  },
});

const femaleCheckbox = computed({
  get: () => {
    return (
      slotPropsRef.value?.filter?.gender?.includes(GENDER_VALUES.FEMALE) ||
      false
    );
  },
  set: (value: boolean) => {
    if (slotPropsRef.value?.filter) {
      slotPropsRef.value.filter.gender = toggleGenderValue(
        slotPropsRef.value.filter.gender || [],
        GENDER_VALUES.FEMALE
      );
    }
  },
});

// Опции для возраста из store
const ageOptions = computed(() => {
  return agesStore.itemList.map((age) => ({
    value: age.id,
    label: age.type,
  }));
});

const updateSlotProps = (slotProps: any) => {
  slotPropsRef.value = slotProps;
  return true;
};

const setParentFilter = (filter: any, isSetted: boolean) => {
  emits("setFilter", filter, isSetted);
};

onMounted(async () => {
  // Загружаем справочник возрастов
  if (agesStore.itemList.length === 0) {
    await agesStore.getItems("", [], true, false, 0, 50, true);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListFilterForm, {
    "is-filter-enabled": props.isFilterEnabled,
    "initial-filter": initialFilter,
    onToggleFilter: _cache[2] || (_cache[2] = ($event: any) => (emits('toggleFilter'))),
    onSetFilter: setParentFilter
  }, {
    fields: _withCtx((slotProps) => [
      (updateSlotProps(slotProps))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_unref(InputText), {
          id: "segmentMame",
          placeholder: "Введите название",
          modelValue: slotProps.filter.name,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.name) = $event),
          "aria-describedby": "username-help"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_unref(Calendar), {
          id: "date",
          panelClass: "not-extended",
          placeholder: "Выберите значение",
          modelValue: slotProps.filter.date,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.date) = $event),
          "aria-describedby": "date-help",
          showIcon: "",
          iconDisplay: "input",
          inputId: "icondisplay"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_unref(MultiSelect), {
          modelValue: slotProps.filter.state,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.state) = $event),
          optionValue: "id",
          options: _unref(segmentsDictionariesStore).statesAllowed,
          optionLabel: "display_name",
          placeholder: "Выберите значение"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(segmentsDictionariesStore).types, (sType) => {
          return (_openBlock(), _createElementBlock("div", {
            key: sType.id,
            class: "flex type-checkbox"
          }, [
            _createVNode(_unref(Checkbox), {
              modelValue: slotProps.filter.type,
              "onUpdate:modelValue": ($event: any) => ((slotProps.filter.type) = $event),
              inputId: `type-${sType.id}`,
              value: sType.id
            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId", "value"]),
            _createElementVNode("label", {
              for: `type-${sType.id}`,
              class: "m-l-10"
            }, _toDisplayString(sType.display_name), 9, _hoisted_10)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(CategoryTreeInput, {
          modelValue: slotProps.filter.category,
          ref: "childCategoryTree",
          isSegmentSetted: false,
          "onUpdate:modelValue": 
          ($event) => (slotProps.filter.category = $event)
        
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(CatalogDataBaseInput, {
          useIdOnly: true,
          selectType: "brand",
          isSegmentSetted: false,
          modelValue: slotProps.filter.brand,
          "onUpdate:modelValue": ($event) => (slotProps.filter.brand = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(CatalogDataBaseInput, {
          useIdOnly: true,
          selectType: "segment_shop",
          isSegmentSetted: false,
          modelValue: slotProps.filter.shop,
          "onUpdate:modelValue": ($event) => (slotProps.filter.shop = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(CatalogDataBaseInput, {
          useIdOnly: true,
          selectType: "user",
          isSegmentSetted: false,
          modelValue: slotProps.filter.user,
          "onUpdate:modelValue": ($event) => (slotProps.filter.user = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_unref(Checkbox), {
                modelValue: maleCheckbox.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((maleCheckbox).value = $event)),
                binary: "",
                "input-id": "maleCheckbox"
              }, null, 8, ["modelValue"]),
              _hoisted_24
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_unref(Checkbox), {
                modelValue: femaleCheckbox.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((femaleCheckbox).value = $event)),
                binary: "",
                "input-id": "femaleCheckbox"
              }, null, 8, ["modelValue"]),
              _hoisted_26
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ageOptions.value, (age) => {
              return (_openBlock(), _createElementBlock("div", {
                key: age.value,
                class: "gender-option"
              }, [
                _createVNode(_unref(Checkbox), {
                  "model-value": 
                  slotPropsRef.value?.filter?.age?.includes(age.value) || false
                ,
                  "onUpdate:modelValue": (value) => {
                  if (slotPropsRef.value?.filter) {
                    slotPropsRef.value.filter.age = _unref(toggleAgeValue)(
                      slotPropsRef.value.filter.age || [],
                      age.value
                    );
                  }
                },
                  binary: "",
                  "input-id": `ageCheckbox${age.value}`
                }, null, 8, ["model-value", "onUpdate:modelValue", "input-id"]),
                _createElementVNode("label", {
                  for: `ageCheckbox${age.value}`,
                  class: "gender-checkbox-label"
                }, _toDisplayString(age.label), 9, _hoisted_31)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-filter-enabled"]))
}
}

})